const updateCategories = (state, { payload: { categories } }) => {
	state.categories = categories;
};

export default updateCategories;
